import { Card, Space, Typography } from "antd";

import { ManageDocs } from "./ManageDocs";
import { useCustomToolStore } from "../../store/custom-tool-store";

function SpsUpload() {
  const { details } = useCustomToolStore();

  return (
    <div className="display-flex-center-h-and-v">
      <Card className="sps-upload-card">
        <Space direction="vertical" size={30}>
          <div className="sps-land-header">
            <Typography.Text strong className="sps-land-title">
              Upload a good sample set of {details?.tool_name} documents
            </Typography.Text>
            <br />
            <Typography.Text type="secondary">
              For the best experience, it is generally a good idea to upload
              between 3 and 5 documents, but you can always start with one or
              two.
            </Typography.Text>
          </div>
          <ManageDocs />
        </Space>
      </Card>
    </div>
  );
}

export { SpsUpload };
